(function() {
  function initCtaPopup(sectionEl) {
    var trigger = sectionEl.querySelector('[data-cta-popup-trigger]');
    if (!trigger) return;

    var sectionId = trigger.getAttribute('data-cta-popup-trigger');
    var overlay = document.getElementById('cta-popup-' + sectionId);
    if (!overlay) return;

    var closeBtn = overlay.querySelector('.cta-popup__popup-close');

    trigger.addEventListener('click', function() {
      overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });

    closeBtn.addEventListener('click', function() {
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        overlay.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
        overlay.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }

  function init() {
    document.querySelectorAll('.section-cta-popup').forEach(function(section) {
      initCtaPopup(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.classList.contains('section-cta-popup')) {
      initCtaPopup(e.target);
    }
  });
})();
